export const SET_STATE = 'hotelPage/SET_STATE';
export const SET_FETCHING = 'hotelPage/SET_FETCHING';
export const SET_HOTELS_INFO = 'hotelPage/SET_HOTELS_INFO';
export const RESET_STATE = 'hotelPage/RESET_STATE';
